import { render } from "./Sefie.vue?vue&type=template&id=606514aa&scoped=true"
import script from "./Sefie.vue?vue&type=script&lang=js"
export * from "./Sefie.vue?vue&type=script&lang=js"

import "./Sefie.vue?vue&type=style&index=0&id=606514aa&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-606514aa"]])

export default __exports__